import React from 'react'
import axios from 'axios'
import {
  Breadcrumb,
  BreadcrumbItem,
  Button, Card,
  CardBody,
  CardHeader, Col,
  Form,
  FormGroup,
  Input, Label, ListGroup, ListGroupItem, Modal, ModalBody, ModalFooter, ModalHeader,
  Row
} from "reactstrap";
import { Link } from 'react-router-dom'
import jwt from "jsonwebtoken";
import moment from 'moment';
import {ToastContainer, toast} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {USER_ROLE} from "../../constants";

class CashDetail extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      cashDetail: {},
      modalEditStatusToggle: false,
      statusArr: [ 'Chưa thu', 'Đã thu'],
      statusArrName: [ 'Thu tiền', 'Hoàn thành'],
      currentStatus: 'Chưa thu',
      currUser: {},
      note: ''
    }
    
    this.openEditStatusModal = this.openEditStatusModal.bind(this)
    this.updateCashStatus = this.updateCashStatus.bind(this)
    this.onEditCashChange = this.onEditCashChange.bind(this)
  }

  async componentDidMount() {
    let { cashId } = this.props.match.params;
    console.log(cashId)
    let token = localStorage.getItem('id_token');
    let currUser = jwt.decode(token);
    this.setState({ currUser: currUser });

    this.getCashDetail(cashId)
  }

  onEditCashChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value })
  }

  getCashDetail = async (cashId) => {
    try {
      const { data } = await axios.get(`/cash-by-id/${cashId}`)
      if (data) {
        this.setState({ cashDetail: data, currentStatus: data.statusType })
      }
    } catch (e) {
      console.log(e)
      toast.error('Không thể tải thông tin thu tiền')
    }
  }

  openEditStatusModal() {
    const { modalEditStatusToggle } = this.state
    this.setState({ modalEditStatusToggle: !modalEditStatusToggle });
  }

  formatNumber(num) {
    if (num) {
      return new Intl.NumberFormat().format(num)
    }
    return num
  }

  async updateCashStatus(e) {
    e.preventDefault();
    try {
      const { cashDetail, currentStatus, note } = this.state
      const nextStatusIndex = this.state.statusArr.indexOf(currentStatus) + 1
      const nextStatus = this.state.statusArr[nextStatusIndex] || 'Đã thu'
      
      const updateData = {
        statusType: nextStatus,
        note: note
      }
      
      if (nextStatus === 'Đã thu') {
        updateData.collectedAt = new Date()
      }
      
      await axios.post(`/update-cash/${cashDetail.id}`, updateData)
      this.setState({ modalEditStatusToggle: false });
      await this.getCashDetail(cashDetail.id)
      toast.success('Cập nhật trạng thái thành công!')
    } catch (err) {
      toast.error('Đã có lỗi xảy ra');
      console.error(err)
    }
  }

  formatDate = (str) => {
    return moment(str).format('DD/MM/YYYY HH:mm')
  }

  checkPermission() {
    try {
      const role = this.state.currUser.role
      if (role === USER_ROLE.ADMIN || role === USER_ROLE.SALER || role === USER_ROLE.CONSULTANT || role === USER_ROLE.MANAGER || role === USER_ROLE.OPS || role === USER_ROLE.SHIPPER) {
        return true
      }
      return false
    } catch (e) {
    }
  }

  isCollector() {
    try {
      const role = this.state.currUser.role
      if (role === USER_ROLE.SHIPPER) {
        return true
      }
      return false
    } catch (e) {
    }
  }

  render() {
    let { cashId } = this.props.match.params;
    const { cashDetail, currentStatus } = this.state
    const nextStatusIndex = this.state.statusArr.indexOf(currentStatus) + 1
    const canUpdateStatus = currentStatus !== 'Đã thu' && this.checkPermission()

    return (
      <div>
        <ToastContainer
          position="top-right"
          autoClose={2000}
          hideProgressBar={true}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
        />
        <Breadcrumb>
          <BreadcrumbItem><Link to="/app/thu-tien-mat">Thu Tiền Mặt</Link></BreadcrumbItem>
          <BreadcrumbItem active>Chi Tiết Thu Tiền</BreadcrumbItem>
        </Breadcrumb>
        <Card style={{marginTop: 20}}>
          <CardHeader className="d-flex justify-content-between align-items-center">
            <span>Thông tin Thu Tiền: CT{cashId}</span>
          </CardHeader>
          <CardBody>
            <ListGroup>
              <ListGroupItem><strong>Mã Thu Tiền:</strong> CT{cashDetail.id} </ListGroupItem>
              <ListGroupItem>
                <div className="d-flex justify-content-start align-items-center">
                  <strong className='mr-3'>Trạng Thái:</strong> 
                  <span className={`badge ${cashDetail.statusType === 'Đã thu' ? 'badge-success' : 'badge-warning'}`}>
                    {cashDetail.statusType}
                  </span>
                  {canUpdateStatus && (
                    <Button className='ml-3 btn btn-primary' onClick={this.openEditStatusModal}>
                      {this.state.statusArrName[nextStatusIndex] || 'Hoàn thành'}
                    </Button>
                  )}
                </div>
              </ListGroupItem>
              <ListGroupItem><strong>Mã KH:</strong> KHTP{cashDetail.customerId}</ListGroupItem>
              <ListGroupItem><strong>Account Tạo:</strong> {cashDetail.owner} </ListGroupItem>
              <ListGroupItem><strong className='text-uppercase'>Thông tin khách hàng:</strong>
                <p><strong>Tên:</strong> {cashDetail.customerName}</p>
                <p><strong>Phone:</strong> {cashDetail.customerPhone}</p>
                <p><strong>Địa chỉ:</strong> {cashDetail.customerAddress}</p>
              </ListGroupItem>
              <ListGroupItem><strong className='text-uppercase mb-2'>Thông tin thu tiền:</strong>
                <div>
                  <p><strong>Mã kiện hàng:</strong> {cashDetail.packageCode}</p>
                  <p><strong>Số tiền thu:</strong> {this.formatNumber(cashDetail.amount)} VNĐ</p>
                  <p><strong>Khu vực:</strong> {cashDetail.location}</p>
                  <p><strong>Thời gian tạo:</strong> {this.formatDate(cashDetail.date)}</p>
                  {cashDetail.collectedAt && (
                    <p><strong>Thời gian thu:</strong> {this.formatDate(cashDetail.collectedAt)}</p>
                  )}
                </div>
              </ListGroupItem>
              {cashDetail.note && (
                <ListGroupItem>
                  <strong>Ghi chú:</strong> {cashDetail.note}
                </ListGroupItem>
              )}
              <ListGroupItem>Ngày Tạo: {this.formatDate(cashDetail.createdAt)}</ListGroupItem>
            </ListGroup>
          </CardBody>

          {/* Modal để cập nhật trạng thái */}
          <Modal isOpen={this.state.modalEditStatusToggle} toggle={this.openEditStatusModal}>
            <Form>
              <ModalHeader toggle={this.openEditStatusModal}>
                Cập nhật trạng thái thu tiền
              </ModalHeader>
              <ModalBody>
                <p>
                  Bạn có chắc chắn muốn cập nhật trạng thái từ <strong>"{currentStatus}"</strong> thành{' '}
                  <strong>"{this.state.statusArr[nextStatusIndex] || 'Đã thu'}"</strong>?
                </p>
                <FormGroup>
                  <Label for="note">Ghi chú (tùy chọn)</Label>
                  <textarea
                    className="form-control"
                    rows="3"
                    id="note"
                    placeholder="Nhập ghi chú..."
                    onChange={this.onEditCashChange}
                    name="note"
                    value={this.state.note}
                  />
                </FormGroup>
              </ModalBody>
              <ModalFooter>
                <Button color="primary" onClick={this.updateCashStatus}>
                  Cập nhật
                </Button>{' '}
                <Button color="secondary" onClick={this.openEditStatusModal}>
                  Hủy
                </Button>
              </ModalFooter>
            </Form>
          </Modal>

        </Card>
      </div>
    )
  }
}

export default CashDetail 